/*eslint-disable*/
import { all, takeLatest } from 'redux-saga/effects';
import { constants } from '../config';

export function* getCookiesModalSaga() {

}

function* actionWatcher() {
  yield takeLatest(constants.SHOW_COOKIES, getCookiesModalSaga);
}

export default function* defaultSaga() {
  yield all([actionWatcher()]);
}
